import React, { useEffect, useState } from 'react'
import { Input as AntInput } from 'antd'
import { InputProps as AntInputProps } from 'antd'
import './styles.css'

interface InputProps extends AntInputProps {
  maxLength?: number
  edit?: boolean
  value?: string | number
}
type AfterLabel = { datacount?: string }
type ClassName = string

const Input = (props: InputProps) => {
  const { maxLength = false, edit = true, value, children, ...rest } = props
  const [className, setClassName] = useState<ClassName>()
  const [afterLabel, setAfterLabel] = useState<AfterLabel>()

  useEffect(() => {
    if (edit && maxLength) {
      const localValue = String(value || '')
      const valueLength = localValue.length
      setClassName(valueLength > maxLength ? 'input-count-over' : 'input-count')
      setAfterLabel({ datacount: `${valueLength}/${maxLength}` })
    } else {
      setClassName('')
      setAfterLabel({})
    }
  }, [value, edit, maxLength])

  return (
    <div className={className} {...afterLabel}>
      <AntInput className={className} value={value} readOnly={!edit} {...rest}>
        {children}
      </AntInput>
    </div>
  )
}

export default Input
export type { InputProps }
